import { User } from '@sr/types';

export default function isPro(user: User | null | false): boolean {
  return (
    (user && typeof user.proUntil === 'number' && user.proUntil > Date.now()) ||
    false
  );
}
